import http from '../services/http'
import { getCredentialToken } from './auth'
import qs from 'qs'

const BEDROCK_API_USER_PROFILE_ENDPOINT = '/bankrate/profile'

export const getUserProfile = async (bearerToken, url) => {
  const response = await http.client.get(
    url
      ? (url += BEDROCK_API_USER_PROFILE_ENDPOINT)
      : BEDROCK_API_USER_PROFILE_ENDPOINT,
    {
      headers: { Authorization: `Bearer ${bearerToken}` }
    }
  )

  if (response.status !== 200) {
    throw response
  }
  return response
}

export const createUserProfile = async (
  bearerToken,
  { firstName, lastName }
) => {
  const response = await http.client.post(
    BEDROCK_API_USER_PROFILE_ENDPOINT,
    {
      personal: {
        first_name: firstName,
        last_name: lastName
      }
    },
    {
      headers: { Authorization: `Bearer ${bearerToken}` }
    }
  )
  if (response.status < 200 || response.status > 299) {
    throw response
  }
  return response
}

export const updateUserProfile = async (bearerToken, profileUpdates) => {
  const response = await http.client.patch(
    BEDROCK_API_USER_PROFILE_ENDPOINT,
    profileUpdates,
    {
      headers: { Authorization: `Bearer ${bearerToken}` }
    }
  )
  if (response.status < 200 || response.status > 299) {
    throw response
  }
  return response
}

export const deleteSavedArticle = async (articleId, bearerToken) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${bearerToken}`
  }
  const data = {
    article_ids: [articleId]
  }

  const response = await http.client.delete(BEDROCK_API_USER_PROFILE_ENDPOINT, {
    headers,
    data
  })

  if (response.status !== 200) {
    throw response
  }
  return response
}

export const saveArticleAuthed = async (articleId, bearerToken) => {
  const response = await http.client.patch(
    BEDROCK_API_USER_PROFILE_ENDPOINT,
    {
      article_ids: [articleId]
    },
    {
      headers: { Authorization: `Bearer ${bearerToken}` }
    }
  )
  if (response.status !== 200) {
    throw response
  }
  return response
}

export const saveCalculatorAuthed = async ({
  url,
  calculator,
  bearerToken
}) => {
  const response = await http.client.patch(
    url
      ? (url += BEDROCK_API_USER_PROFILE_ENDPOINT)
      : BEDROCK_API_USER_PROFILE_ENDPOINT,
    {
      calculators: [calculator]
    },
    {
      headers: { Authorization: `Bearer ${bearerToken}` }
    }
  )

  if (response.status !== 200) {
    throw response
  }

  return response
}

export const saveArticle = async articleID => {
  const bearerToken = getCredentialToken()
  const response = await http.client.patch(
    BEDROCK_API_USER_PROFILE_ENDPOINT,
    qs.stringify({
      articleID
    }),
    {
      headers: { Authorization: `Bearer ${bearerToken}` }
    }
  )
  if (response.status !== 200) {
    throw response
  }
  return response
}
